import React, { Fragment } from 'react'

import type { FeatureFlagDecoratorProps } from './props'
import * as S from './styled'

export const FeatureFlagDecorator = ({
  enabled,
  description,
  display = 'block',
  highlight = false,
  spacing = 'regular',
  descriptionPosition = 'inside',
  wrapper = Fragment,
  children,
}: FeatureFlagDecoratorProps) => {
  if (!enabled) return null

  const Wrapper = wrapper

  if (!highlight) return <Wrapper>{children}</Wrapper>

  return (
    <Wrapper>
      <S.Container spacing={spacing} display={display}>
        {description && (
          <S.Description position={descriptionPosition}>
            <div>{description}</div>
          </S.Description>
        )}
        {children}
      </S.Container>
    </Wrapper>
  )
}
